import { ACTION_STATUS } from "constants/actions";
import ObservationActionSuggestion from "./ObservationActionSuggestion";
import ObservationActionPerformed from "./ObservationActionPerformed";

const ObservationActionDetails = ({ viewMode, status }) => {
  if (status !== ACTION_STATUS.performed) {
    return <ObservationActionSuggestion viewMode={viewMode} isFullWidth />;
  } else {
    return <ObservationActionPerformed viewMode={viewMode} isFullWidth />;
  }
};

export default ObservationActionDetails;
